import { Resources } from 'constants/resources';

import React from 'react';

import { useCreatePathWithQuery } from 'hooks/useCreatePathWithQuery';
import { ReactComponent as CompletedReport } from 'images/completedReport.svg';
import { Link } from 'react-router-dom';
import { ContextMenuButton } from 'shared/mui/ContextMenu';
import { DEFAULT_TIMEZONE } from 'shared/mui/DatePicker/config/defaultValues';
import {
  DateRangeTimezoneValue,
  DateRangeValue,
} from 'shared/mui/DatePicker/DateTimeRangeTimezonePicker/DateTimeRangeTimezonePicker';
import {
  CompanyBalanceReport,
  MerchantAccountBalanceReport,
  MerchantBalanceReport,
  ProviderBalanceReport,
} from 'types/embedded/balanceReport';
import { formatInputToTimestamp } from 'utils/date';
import { convertReactAdminIdToHydraId } from 'utils/index';

type Props = {
  appliedDate?: DateRangeValue;
  timezone?: DateRangeTimezoneValue;
  merchantAccount: MerchantAccountBalanceReport;
  merchant: MerchantBalanceReport;
  provider: ProviderBalanceReport;
  company: CompanyBalanceReport;
};

export const ContextMenuOrdersReportLink: React.FC<Props> = ({
  merchantAccount,
  provider,
  merchant,
  company,
  appliedDate,
  timezone,
}) => {
  const { createPathWithQuery } = useCreatePathWithQuery();
  const to = createPathWithQuery(
    {
      resource: Resources.OrdersReport,
      type: 'list',
    },
    {
      filter: {
        merchantAccount: [convertReactAdminIdToHydraId(merchantAccount.id, 'merchant_accounts')],
        provider: convertReactAdminIdToHydraId(provider.id, Resources.Providers),
        merchant: convertReactAdminIdToHydraId(merchant.id, Resources.Merchants),
        company: convertReactAdminIdToHydraId(company.id, Resources.Companies),
        transactions: {
          createdAt: {
            gte: formatInputToTimestamp(appliedDate?.[0], { unit: 'seconds' }),
            lte: formatInputToTimestamp(appliedDate?.[1], { unit: 'seconds' }),
          },
        },
        timezone: timezone || DEFAULT_TIMEZONE,
      },
    },
  );

  return (
    <Link style={{ textDecoration: 'none' }} target="_blank" to={to}>
      <ContextMenuButton
        icon={<CompletedReport />}
        label={'Исполненные транзакции\nза выбранный период'}
      />
    </Link>
  );
};
